
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Helpers from '@/logic/orders/helpers';
import OrderContainerList from '@/components/orders/OrderContainerList.vue';
import OrderItemList from '@/components/orders/OrderItemList.vue';
import OrderStatus from '@/components/orders/OrderStatus.vue';
import { SalesOrderAll as SalesOrder } from '@/logic/orders/SalesOrderAll';

@Component({
  components: { OrderContainerList, OrderItemList, OrderStatus },
})
export default class OrderCard extends Vue {
  @Prop(Object)
  order!: SalesOrder;

  @Prop({ default: 'default' })
  type!: 'default' | 'modal';

  loading = false;

  Helpers = Helpers;

  get orderNo(): string | undefined {
    return this.order.OrderNumber || undefined;
  }

  get orderRef(): string | undefined {
    return this.order.PurchOrder || undefined;
  }

  get orderCity(): string | undefined {
    return this.order.City || undefined;
  }

  get fullOrderDate(): string | null {
    return Helpers.getReadableCreatedFullDate(this.order);
  }

  get orderDate(): string | null {
    return Helpers.getReadableCreatedDate(this.order);
  }

  get active(): boolean {
    if (this.isNewOrder || this.type === 'modal') {
      return true;
    }
    return this.$store.getters['order/isActive'](this.order.Id);
  }

  get toggleText(): string {
    const key = this.active ? 'close' : 'more';
    return this.$t(`orders.card.header.${key}`) as string;
  }

  get isNewOrder(): boolean {
    return this.order.Id === undefined;
  }

  @Watch('active', { immediate: true })
  activeChanged(active: boolean) {
    if (active) {
      if (this.order.Id) {
        this.$store.dispatch('order/fetchOrder', this.order.Id);
      }
    }
  }

  toggleActive(active: boolean) {
    this.$store.commit('order/toggleActive', {
      id: this.order.Id,
      active,
    });
  }

  async reOrder() {
    this.loading = true;
    await this.$store.dispatch('order/reOrder', this.order).then(() => {
      this.loading = false;
      this.$router.push({ name: 'new-order' });
    });
  }
}
